(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.lastScrollTop = 0;
      this.headerWrapper = null;
      this.headerInner = null;
      this.isSticky = false;
      this.ticking = false;
    }

    connectedCallback() {
      this.headerWrapper = this.closest('.section-header');
      this.headerInner = this.querySelector('.og-header-section');

      if (!this.headerWrapper || !this.headerInner) return;

      this.stickyType = this.getAttribute('data-sticky-type');

      this.setHeaderHeight();
      this.handleResize = this.setHeaderHeight.bind(this);
      window.addEventListener('resize', this.handleResize);

      if (this.stickyType === 'always') {
        this.enableSticky();
      }

      this.handleScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    setHeaderHeight() {
      if (!this.headerInner) return;
      const headerHeight = this.headerInner.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

      if (this.isSticky) {
        this.headerWrapper.style.minHeight = `${headerHeight}px`;
      } else {
        this.headerWrapper.style.minHeight = '';
      }
    }

    enableSticky() {
      if (this.isSticky) return;

      this.isSticky = true;
      this.headerWrapper.classList.add('is-sticky-active');
      this.headerInner.classList.add('is-sticky');
      this.headerInner.classList.remove('is-hidden');
      this.headerWrapper.style.minHeight = `${this.headerInner.offsetHeight}px`;
    }

    disableSticky(resetWrapper = false) {
      this.isSticky = false;
      this.headerWrapper.classList.remove('is-sticky-active');
      this.headerInner.classList.remove('is-sticky', 'is-hidden');

      if (resetWrapper) {
        this.headerWrapper.style.minHeight = '';
      }
    }

    onScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.stickyType === 'none') {
          this.disableSticky(true);
          this.lastScrollTop = currentScrollTop;
          this.ticking = false;
          return;
        }

        const triggerPoint = this.headerWrapper.offsetTop + this.headerInner.offsetHeight;

        if (this.stickyType === 'always') {
          if (currentScrollTop > 0) {
            this.enableSticky();
          } else {
            this.disableSticky();
          }

          this.lastScrollTop = currentScrollTop;
          this.ticking = false;
          return;
        }

        if (currentScrollTop > triggerPoint) {
          this.enableSticky();

          if (currentScrollTop > this.lastScrollTop) {
            this.headerInner.classList.add('is-hidden');
          } else {
            this.headerInner.classList.remove('is-hidden');
          }
        } else {
          this.disableSticky(true);
        }

        this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
        this.ticking = false;
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
